var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.972 18.68a.273.273 0 0 1-.273-.273V14.52C2.312 13.279 1 11.106 1 8.382 1 4.174 4.869 1 10 1s9 3.174 9 7.382-3.869 7.382-9 7.382c-.168 0-.334-.01-.5-.018h-.01l-4.368 2.888a.27.27 0 0 1-.15.045m1.17-8.869a1.286 1.286 0 1 0 0-2.571 1.286 1.286 0 0 0 0 2.571m3.858 0a1.286 1.286 0 1 0 0-2.571 1.286 1.286 0 0 0 0 2.571m3.857 0a1.286 1.286 0 1 0 0-2.572 1.286 1.286 0 0 0 0 2.572"
})));
export default SvgComment;